export default __webpack_public_path__ + "static/media/LightingFix2.3d2c0646.jpg";